import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import '../../node_modules/slick-carousel/slick/slick-theme.css'
import '../../node_modules/slick-carousel/slick/slick.css'
import { isAxiosError, AxiosErrorHandler } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Top extends Mixins(CommonView) {
    private newsList: SBAPI.News[] = [];

    private bannerList: SBAPI.Banner[] = [];
    // public bannerList = BANNER_LIST;

    private slickOk: boolean = false;
    public slickOptions = {
        centerPadding: '85px',
        dots: true,
        centerMode: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        autoplaySpeed: 5000,
        responsive: [{
            breakpoint: 750,
            settings: {
                centerMode: false,
                arrows: false,
            }
        }]
    }

    public async created() {

        let newsList = await SBAPI.NewsController.getNewsListUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(newsList)) {
            return;
        }
        this.newsList = newsList.data;

        let bannerList = await SBAPI.BannerController.getBannerListUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(bannerList)) {
            return;
        }
        this.bannerList = bannerList.data;

        this.slickOk = true;
    }
}
